<script setup lang="ts">
defineProps<{
  formattedSearchCriteria: string
}>();
</script>

<template>
  <div>
    <IadTitle
      :text="$t(`property_serp.alert_dialog.criteria_title`)"
      tag="p"
      class="pb-xs"
      variant="small-semibold"
    />
    <p v-text="formattedSearchCriteria" />
  </div>
</template>
